export function isIngame(): boolean {
  return window?.navigator?.userAgent?.includes('WOWS/1.0') || false;
}
